<template>
  <div id="app">
    <img class="logoimg" src="./assets/logo.png">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

body {
  background-image: url(./assets/play-dots.png);
  background-color: #fdfdea;
  background-size: 32px 32px;
  height: 100%;
}

html {
  height: 100%;
}

.logoimg {
  width: 300px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue